import { ActionTypes as actions } from '../actions';

const initialState = {
  instantSessions: null,
  sessionsStatusDict: null,
}

export default function PracticeReducer(state=initialState, action) {

  switch(action.type) {
    case actions.EMG_INSTANT_SESSIONS_UPDATE:
      state = { ...state, instantSessions: action.payload };
      break;
    case actions.EMG_SESSIONS_STATUS_DICT_UPDATE:
      state = { ...state, sessionsStatusDict: action.payload };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
